<template>
  <div class="app" :class="{'app--onHome': this.onHome}">
    <div class="app__content" :class="{ 'app__content--blur': blurMode}">
      <NavMenu />
      <div class="app__page">
        <router-view :key="$route.fullPath" />
      </div>
      <ContactUsAction v-show="ContactUsActionShow" :text="ContactUsActionText" />
      <FooterBlock />
    </div>

    <FilterUI :actived="blurMode" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ContactUsAction from "@/components/ContactUsAction";
import NavMenu from "@/sections/NavMenu";
import FilterUI from "@/components/FilterUI";
import FooterBlock from "@/sections/FooterBlock";
export default {
  name: "app",
  components: {
    FilterUI,
    NavMenu,
    FooterBlock,
    ContactUsAction
  },
  created() {
    window.scrollTo(0, 0);
  },
  computed: {
    ...mapGetters(["mobileMenu"]),
    onHome() {
      return this.$route.name === "home";
    },
    blurMode() {
      return this.$store.state.turnFilterUI;
    },
    ContactUsActionShow() {
      return (
        this.$route.name !== "home" &&
        this.$route.name !== "sobre" &&
        this.$route.name !== "contato"
      );
    },
    ContactUsActionText() {
      const text = [
        "Descubra como a Magor pode ajudar o seu negócio.",
        "Fale com a nossa equipe. Deixe uma mensagem."
      ];

      const rand = Math.floor(Math.random() * text.length);

      return text[rand];
    }
  }
};
</script>

<style lang="scss">
@import url("https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.min.css");
@import "./assets/css/vars";
@import "./assets/css/font";

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  outline: 0;
  &,
  &:before,
  &:after {
    box-sizing: inherit;
  }
}

html {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  box-sizing: border-box;

  @media (min-width: $min-lg) {
    font-size: 10px;
  }
  @media (max-width: $max-md) {
    font-size: 7px;
  }
  @media (max-width: $max-sm) {
    font-size: 10px;
  }
}

.app {
  background-color: transparent;
  @media (max-width: $max-sm) {
    &--stopScrolling {
      overflow: hidden;
    }
    &__content--blur {
      .navmenu img,
      .app__page {
        filter: blur(5px);
      }
    }
  }
}
</style>
